import { Switch } from '@heroui/react';

/* A settings row: leading icon + title + description, trailing HeroUI Switch.
   Used for the Step-4 publishing toggles. */
export default function RowToggle({ icon, title, desc, on, onChange }) {
	return (
		<div className="flex items-center gap-3.5 px-3.5 py-3">
			<div className="w-9 h-9 rounded-xl bg-slate-100 text-slate-500 grid place-items-center flex-none">
				{icon}
			</div>
			<div className="flex-1 min-w-0">
				<div className="text-sm font-semibold text-slate-800">{title}</div>
				{desc && <div className="text-[12px] text-slate-500 mt-0.5 leading-snug">{desc}</div>}
			</div>
			<Switch isSelected={on} onValueChange={onChange} color="primary" size="sm" aria-label={title} />
		</div>
	);
}
